export class NotSupportedError extends Error {
    readonly name: string = "NotSupportedError";

    constructor(message: string) {
        super(message);
        Object.setPrototypeOf(this, new.target.prototype);
    }
}
